<template>
  <div ref="turnstileContainer" />
</template>

<script>
export default {
  name: "Turnstile",
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      widgetId: null,
      checkInterval: null,
    };
  },
  mounted() {
    this.initializeTurnstile();
  },
  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  },
  methods: {
    initializeTurnstile() {
      if (window.turnstile && typeof window.turnstile.render === "function") {
        this.renderWidget();
      } else {
        // Jalankan polling hingga window.turnstile siap
        this.checkInterval = setInterval(() => {
          if (
            window.turnstile &&
            typeof window.turnstile.render === "function"
          ) {
            clearInterval(this.checkInterval);
            this.renderWidget();
          }
        }, 100);

        // Bersihkan interval setelah 10 detik jika gagal load
        setTimeout(() => {
          if (this.checkInterval) {
            clearInterval(this.checkInterval);
          }
        }, 10000);
      }
    },
    renderWidget() {
      // Hindari double render jika callback & polling terpicu bersamaan
      if (this.widgetId) return;

      try {
        this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
          sitekey: this.siteKey,
          callback: (token) => {
            this.$emit("verified", token);
          },
          "error-callback": (error) => {
            this.$emit("error", "Turnstile " + error);
          },
          "expired-callback": () => {
            this.$emit("expired");
          },
        });
      } catch (e) {
        console.error("Turnstile render error:", e);
      }
    },
  },
};
</script>
